module.exports = __webpack_public_path__ + "static/img/24.18e2a00a.png";